import { NgModule, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaintimelineviewComponent } from './maintimelineview/maintimelineview.component';
import { EventsummaryComponent } from '../timeline/eventsummary/eventsummary.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../shared/shared.module';


@NgModule({
    declarations: [MaintimelineviewComponent, EventsummaryComponent],
    imports: [
        CommonModule,
        NgbModule,
        SharedModule
    ],
    exports: []
})
export class TimelineModule {
}

// translation loader moved to SharedModule
